import { TemplateEngine } from "../../../js/lib/TemplateEngine";
import { TLCEXT } from "../../../js/lib/ext/Ext";
import { DialogManagerConfig } from "./DialogManagerConfig";

export const DialogManager = (function( $ ) {
	var dialog,
		dialogContainer,
		dialogContent,
		dialogForm,
		submitFalse,
		useForm,
		dialogButtons,
		isOpen = false,
		isOpening = false,
		isClosing = false,
		currentOptions,
		constants = {
			mainId:                "dialogContainer",
			contentContainerClass: 'dialogContentContainer',
			targetId: 'dialogTargetContainer',
			formId:                "dialog_form",
			contentId:             "dialog_form_content",
			buttonsId:             "dialog_form_buttons",
			headingId:             "dialog_heading",
			templatePath:          "tmpl/dialog.html"
		},
		getOptions = function( newOptions ) {
			var baseOptions = {
				buttons:               "<input type=\"submit\" class=\"{submitClass}\" value=\"{okText}\" /><input type=\"button\" class=\"{cancelClass} close\" value=\"{cancelText}\" />",
				cancelText:            "Cancel",
				okText:                "Ok",
				closeAfterSubmit:      true,
				showCancel:            true,
				submitClass:           "TEMP_muiContainedButton",
				cancelClass:           "TEMP_muiTextButton",
				submitFalse:           true,
				useForm:               true,
				onBeforeEmptyCallback: null
			};
			return $.extend( {}, baseOptions, DialogManagerConfig.getBaseConfig(), newOptions );
		},
		scrollY;

	var appendDialog = function( callback, options ) {
		options.buttons = TLCEXT.Template( options.buttons ).populate( options );
		var destinationEle = $( "#" + constants.targetId );

		if( destinationEle.length == 0 ) {
			destinationEle = $( document.body );
		}

		if( !dialog ) {
			TemplateEngine.fetch( constants.templatePath, destinationEle, options, function( ext, temp ) {
				dialog = $( "#" + constants.mainId );

				$( document ).on("keyup", function( e ) {
					// esc key
					if( e.keyCode == 27 ) {
						if( isOpen ) {
							DialogManager.close( options );
						}
					} else if( e.keyCode == 13 ) {
						if( isOpen ) {
							dialog.find( "#" + constants.formId ).trigger("submit");
						}
					}
				} );

				dialogContent = $( "#" + constants.contentId );
				dialogButtons = $( "#" + constants.buttonsId );

				dialogContainer = $( "#dialogContainer .dialogContentContainer" );

				addSubmitDelegate( options );

				if( callback ) callback();
			} );
		} else {
			$( "#" + constants.headingId ).html( options.dialogTitle );
			dialogButtons.html( options.buttons );
			addSubmitDelegate( options );
			if( callback ) callback();
		}
	};

	var addSubmitDelegate = function( options ) {
		dialog.on("submit", "#" + constants.formId, function( event ) {
			if( isOpen ) {
				if( options.submitCallback ) {
					options.submitCallback( event );
				}
				if( options.closeAfterSubmit ) {
					DialogManager.close( options, true );
				}
			}

			if( options.submitFalse ) {
				return false;
			}
		} );

		dialog.on("click", ".close", function( event ) {
			DialogManager.close( currentOptions );
			return false;
		} );

		dialog.on("click", ".external",  function( event ) {
			if( options.externalCallback ) {
				options.externalCallback( event );
			}
		} );

		dialog.on("click", ".register", function( event ) {
			if( options.registerCallback ) {
				options.registerCallback( event );
			}
		} );
	};

	return {
		getSubmitButton: function() {
			if( dialogButtons ) {
				return dialogButtons.find( "input:submit" );
			}
			return null;
		},
		constants:       constants,
		show:            function( newOptions ) {
			if( isClosing === true ) {
				setTimeout( function() {
					DialogManager.show( newOptions );
				}, 250 );
			}
			else if( isOpening === false ) {//TODO if, a dialog is already in the process of opening we ignore successive show calls until it's opened?
				isOpening = true;
				var options = getOptions( newOptions );
				currentOptions = options;
				appendDialog( function() {

					if( currentOptions.extraClass ) {
						dialogContainer.addClass( currentOptions.extraClass );
					}


					if( isOpen ) {
						dialogContent.empty();
					}

					scrollY = (window.scrollY !== undefined
						) ? window.scrollY : document.documentElement.scrollTop;
					window.scrollTo( 0, 0 );

					dialogContent.append( options.content );

					dialog.fadeIn( 200, function() {
						if( options.callback ) {
							options.callback();
						}
						isOpen = true;
						isOpening = false;
					} );

					dialogButtons.find( "input:submit" ).trigger("focus");
					if( options.showCancel == false ) {
						dialogButtons.find( "input.close" ).hide();
					}
				}, options );
			}
		},
		close:           function( options, closedViaSubmit ) {
			closedViaSubmit = closedViaSubmit || false;
			options = options || currentOptions || {};
			if( isOpen ) {
				isClosing = true;

				dialog.fadeOut( 200, function() {

					if( currentOptions.extraClass ) {
						dialogContainer.removeClass( currentOptions.extraClass );
					}

					if( typeof options.onBeforeEmptyCallback === "function" ) {
						options.onBeforeEmptyCallback();
					}

					dialogContent.empty();
					dialogButtons.empty();
					if( options.closeCallback ) {
						options.closeCallback( closedViaSubmit );
					}
					isOpen = false;
					isClosing = false;

					if( scrollY && (scrollY <= $( document ).height()
						) ) {
						window.scrollTo( 0, scrollY );
						scrollY = undefined;
					}

				} );
				dialog.off();
			}

		}
	};

})( jQuery );
